import React from 'react';
import { useTranslation } from 'react-i18next'; // useTranslation hook-ის იმპორტი
import ConveyorImg from "../../../assets/images/Conveyor.png";
import ElevatorImg from "../../../assets/images/ElevatorImg.png";
import HopperImg from "../../../assets/images/Hopper.png";

function Reception() {
  const { t } = useTranslation(); // useTranslation hook-ის გამოყენება

  const products = [
    {
      name: t("Conveyor"),
      description: t(
        "Our range of conveyor belts for harvesting equipment is made up of a unit designed for the conveyance of manual or mechanical grapes, whole or de-stemmed, as well as fermented grapes and pomace. These systems ensure smooth and efficient grape processing."
      ),
      img: ConveyorImg,
    },
    {
      name: t("Elevator"),
      description: t(
        "Elevators are an integral part of any crush pad. They allow you to load grapes at ground level and discharge them into the next piece of equipment—tank, press, destemmer, etc.—at a controlled rate, ensuring seamless workflow."
      ),
      img: ElevatorImg,
    },
    {
      name: t("Hopper"),
      description: t(
        "Grape reception is an essential part of winemaking. A grape hopper will allow the procedure to run a lot smoother, and you will achieve better results from your destemmer when fed at a constant speed. This system saves labor and increases efficiency."
      ),
      img: HopperImg,
    },
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          <img src={product.img} alt={product.name} />
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Reception;
